<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-card>
      <el-form class="search-form" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.SendingTime')">
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :end-placeholder="$t('collectionCenter.EndTime')"
                :start-placeholder="$t('collectionCenter.StartTime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('trajectory.receiverPhoneNumber')">
              <el-input
                v-model="queryParams.params.phoneNumber"
                :maxlength="20"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('trajectory.receiverTarget')">
              <el-input
                v-model="queryParams.params.receiverName"
                :maxlength="15"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('trajectory.smsType')">
              <el-select
                v-model="queryParams.params.smsType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in sMSTypeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item :label="$t('trajectory.sendStatus')">
              <el-select
                v-model="queryParams.params.sendStatus"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in sendStatusList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('trajectory.businessSystem')">
              <el-select
                v-model="queryParams.params.businessSystem"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in businessSystemList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('trajectory.sendChannel')">
              <el-select
                v-model="queryParams.params.sendChannel"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in sendingChannelList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9" style="margin-top: 27px">
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" @click="handleSearch">
                {{ $t('GlobalSetObj.search') }}
              </el-button>
              <el-button icon="el-icon-refresh" @click="handleReset">
                {{ $t('GlobalSetObj.reset') }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <!-- 数据表格 -->
    <el-card style="margin-top: 15px">
      <div class="flx-between" style="margin-bottom: 15px">
        <div>
          <span style="font-size: 16px; font-weight: bold">
            {{ $t('trajectory.smsSendRecord') }}
          </span>
          <span style="font-size: 12px">
            {{ $t('trajectory.verificationCodeDesensitization') }}
          </span>
        </div>
        <el-button v-permit:remove="'btn:LogManagement:sMSSendingLogExport'" @click="handleExport">
          {{ $t('trajectory.BulkExport') }}
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        highlight-current-row
        size="small"
        style="width: 100%"
      >
        <el-table-column
          :label="$t('collectionCenter.SendingTime')"
          min-width="150"
          prop="createTime"
        />
        <el-table-column
          :label="$t('trajectory.smsType')"
          min-width="120"
          prop="smsTypeDesc"
          show-overflow-tooltip
        />
        <el-table-column
          :label="$t('trajectory.receiverPhoneNumber')"
          min-width="130"
          prop="phoneNumber"
        />
        <el-table-column
          :label="$t('trajectory.receiverTarget')"
          min-width="130"
          prop="receiverName"
        />
        <el-table-column
          :label="$t('trajectory.businessSystem')"
          min-width="100"
          prop="businessSystemDesc"
          show-overflow-tooltip
        />
        <el-table-column
          :label="$t('collectionCenter.messageContent')"
          min-width="260"
          prop="content"
          show-overflow-tooltip
        />
        <el-table-column
          :label="$t('trajectory.sendChannel')"
          min-width="90"
          prop="sendChannelDesc"
          show-overflow-tooltip
        />
        <el-table-column
          :label="$t('trajectory.sendStatus')"
          min-width="100"
          prop="sendStatusDesc"
        />
        <el-table-column
          :label="$t('receivablePayable.ReasonForFailure')"
          min-width="180"
          prop="failureReason"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span v-if="row.failureReason" class="fail-reason">{{ row.failureReason }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryParams.pageNumber"
          :page-size.sync="queryParams.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { smsSendLogPage, smsSendLogPageExport } from '@/api/newExpressAPI';
import { getCustomerTimeList } from '@/api/customer';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'SmsSendRecord',
  data() {
    return {
      timeValue: [],
      loading: false,
      tableData: [],
      queryParams: {
        pageNumber: 1,
        pageSize: 20,
        params: {
          beginTime: '',
          endTime: '',
          phoneNumber: '',
          receiverName: '',
          smsType: '',
          sendStatus: '',
          businessSystem: '',
          sendChannel: '',
          maskData: true
        }
      },
      total: 0,
      sMSTypeList: [],
      sendStatusList: [],
      businessSystemList: [],
      sendingChannelList: []
    };
  },
  watch: {
    // 监听时间选择器变化，自动同步到查询参数
    timeValue: {
      handler(val) {
        if (val && val.length === 2) {
          this.queryParams.params.beginTime = val[0];
          this.queryParams.params.endTime = val[1];
        } else {
          this.queryParams.params.beginTime = '';
          this.queryParams.params.endTime = '';
        }
      },
      immediate: true // 组件挂载时立即执行
    }
  },
  async mounted() {
    this.getTimer();
    await Promise.all([this.getRecordField(), this.getSearchData()]);
  },
  methods: {
    async getRecordField() {
      const [res1, res2, res3, res4] = await Promise.all([
        getCustomerTimeList('send_status'),
        getCustomerTimeList('sms_type'),
        getCustomerTimeList('business_system'),
        getCustomerTimeList('sms_push_method')
      ]);

      this.sendStatusList = res1.data || [];
      this.sMSTypeList = res2.data || [];
      this.businessSystemList = res3.data || [];
      this.sendingChannelList = res4.data || [];
    },

    async getSearchData() {
      this.loading = true;
      const buttonPermissions = this.$store.getters.button_permissions;
      const isSeeData = buttonPermissions.includes('btn:LogManagement:sMSSendingLogData');
      if (isSeeData) {
        this.queryParams.params.maskData = false;
      } else {
        this.queryParams.params.maskData = true;
      }
      try {
        const result = await smsSendLogPage(this.queryParams);
        if (result.code === 200) {
          this.total = result.data.total; // 使用真实的总数
          this.tableData = result.data.records;
        }
      } catch (error) {
        console.error('查询失败:', error);
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.queryParams.pageNumber = 1;
      this.getSearchData();
    },

    handleReset() {
      // 重置时间
      this.getTimer();
      // 重置查询参数
      this.queryParams = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          beginTime: this.timeValue[0] || '',
          endTime: this.timeValue[1] || '',
          phoneNumber: '',
          receiverName: '',
          smsType: '',
          sendStatus: '',
          businessSystem: '',
          sendChannel: ''
        }
      };
      this.handleSearch();
    },

    handleExport() {
      smsSendLogPageExport(this.queryParams.params).then(() => {
        goResourceTaskList();
      });
    },

    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.queryParams.pageNumber = 1;
      this.getSearchData();
    },

    handlePageChange(val) {
      this.queryParams.pageNumber = val;
      this.getSearchData();
    },

    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryParams.params.beginTime = this.timeValue[0];
      this.queryParams.params.endTime = this.timeValue[1];
    }
  }
};
</script>

<style lang="scss" scoped>
.fail-reason {
  color: #f56c6c;
  font-size: 12px;
}

.no-fail-reason {
  color: #c0c4cc;
}
</style>
